import { render, staticRenderFns } from "./previewordetaildialog.vue?vue&type=template&id=5d982542&scoped=true&"
import script from "./previewordetaildialog.vue?vue&type=script&lang=js&"
export * from "./previewordetaildialog.vue?vue&type=script&lang=js&"
import style0 from "./previewordetaildialog.vue?vue&type=style&index=0&id=5d982542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d982542",
  null
  
)

export default component.exports